import React from "react";

const HuntTrackerContext = React.createContext();
HuntTrackerContext.displayName = "Hunt Tracker Context";

// Example Call: dispatch({type: "language", value: value});
function reducer(state, action) {
    switch (action.type) {
        case "Language": {
            return { ...state, language: action.value };
        }
        case "DarkMode": {
            return { ... state, darkMode: action.value };
        }
        case "User": {
            return { ... state, user: action.value };
        }
        case "Audio": {
            return { ... state, audioPermission: action.value };
        }
        case "Volume": {
            return { ... state, audioVolume: action.value };
        }
        case "DataCenter": {
            return { ... state, dataCenter: action.value };
        }
        default: {
            throw new Error();
        }
    }
}

function HuntTrackerContextProvider({initialStates, children}) {
    const [controller, dispatch] = React.useReducer(reducer, initialStates);
    const value = React.useMemo(() => [controller, dispatch], [controller, dispatch]);
    return <HuntTrackerContext.Provider value={value}>{children}</HuntTrackerContext.Provider>;
}

function useHuntTrackerContext() {
    const context = React.useContext(HuntTrackerContext);
    if (!context) {
        throw new Error();
    }
    return context;
}

export {
    HuntTrackerContextProvider,
    useHuntTrackerContext,
}